@if (items().length === 0) {
<lib-message [type]="isInDialog() ? 'noDataOnBody' : 'noData'"> There are no exercises </lib-message>
} @if (items(); as items) { @if (items.length) {

<div class="ui-exercise-list">
	@if (useSearchAndFilters()) {

	<div libFlexRow [libFlexRowAlign]="'center'" [libFlexRowGap]="'16px'">
		<div libFlexColumn [libFlexSize]="'fill'">
			<lib-search-input (search)="handleSearch($event)"></lib-search-input>
		</div>
		<div libFlexColumn [libFlexSize]="undefined">
			<lib-button
				[buttonType]="'basic'"
				[icon]="showFilters() ? 'hide' : 'filters'"
				(click)="showFilters.set(!showFilters())"
				>{{ showFilters() ? 'Hide filters' : 'Show filters' }}</lib-button
			>
		</div>
	</div>

	@if (showFilters()) {
	<div class="ui-exercise-list-filters push-top-md">
		<lib-card class="push-top-sm" [isCollapsible]="false" [buttons]="filterButtons" [buttonsMode]="'block'">
			<div class="push-top">
				<div [libFlexRow]="true" [libFlexRowGap]="'16px'">
					@for (filter of filters; track filter.title) {
					<div libFlexColumn [style.width]="calculateFlexWidth(filtersColumnsPerRow(), 16)">
						<ui-select-item-field
							(selectedItemChange)="setActiveFilter(filter, $event)"
							[items]="filter.options"
							[placeholder]="'All'"
							[title]="filter.title"
							[design]="'card'"
							[addClearButton]="true"
							(clearButtonClick)="handleClearFilter(filter)"
						></ui-select-item-field>
					</div>
					}
				</div>
			</div>
		</lib-card>
	</div>
	}

	<div libText3 class="push-top push-bottom">{{ filterSubtitle() }}</div>

	} @if (displayedItems(); as displayedItems) { @if (displayedItems.length === 0) {
	<lib-message [type]="isInDialog() ? 'noDataOnBody' : 'noData'">
		<ng-container>No exercises matched your filters</ng-container>
	</lib-message>
	} @if (displayedItems.length) { @for (item of displayedItems; track item.id; let first = $first; let last = $last) {
	<div>
		<ng-template #imagesTemplate>
			<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="isMobileView() ? 'start' : 'center'">
				@for (image of item.filteredImages; track image.originalImage.absoluteUrl; let index = $index) {
				<div libFlexColumn>
					<lib-image
						[alt]="'Image preview'"
						[imageSize]="'50px'"
						[image]="image"
						[isRound]="false"
						[dialogPreviewImage]="image"
					></lib-image>
				</div>
				}
			</div>
		</ng-template>

		<ng-template #exerciseTemplate>
			@if (isMobileView()) {
			<div class="item" [class.first]="first" [class.last]="last">
				<div>
					<div libFlexRow [libFlexRowGap]="'8px'">
						<div libFlexColumn libFlexFill>
							<h4 libLineClamp class="title" [clampLines]="2">
								{{ item.name }}
							</h4>
						</div>
					</div>
				</div>

				@if (item.videoUrl) {
				<div libFlexRow class="push-top-sm">
					<div libFlexColumn [libFlexSize]="'fill'">
						<lib-video [url]="item.videoUrl"></lib-video>
					</div>
				</div>
				} @else if (showImages(item)) {
				<div libFlexRow class="push-top-sm" [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
					@for (image of item.filteredImages; track image.originalImage.absoluteUrl; let index = $index) {
					<div libFlexColumn libFlexFill>
						<lib-image
							[alt]="'Image preview'"
							[imageSize]="'250px'"
							[isResponsive]="true"
							[maxHeight]="150"
							[image]="image"
							[isRound]="false"
							[dialogPreviewImage]="image"
						></lib-image>
					</div>
					}
				</div>
				} @if (item.infoTableItems.length) {
				<ui-info-table
					[hideEmptyItems]="true"
					class="push-top-sm"
					[items]="item.infoTableItems"
				></ui-info-table>
				}

				<div libFlexColumn libFlexFill class="push-top-sm">
					<lib-button [buttonType]="'primary'" (click)="handleSelectItem(item)">{{
						selectExerciseButtonText()
					}}</lib-button>
				</div>
			</div>
			} @else {
			<div
				(click)="handleSelectItem(item)"
				class="item"
				[class.first]="first"
				[class.last]="last"
				libFlexRow
				[libFlexRowGap]="'16px'"
			>
				@if (item.videoUrl) {
				<div libFlexColumn [libFlexSize]="'300px'">
					<lib-video [url]="item.videoUrl"></lib-video>
				</div>
				} @else if (showImages(item)) {
				<div libFlexColumn [libFlexSize]="'300px'">
					<div libFlexRow [libFlexRowGap]="'16px'">
						@for (image of item.filteredImages; track image.originalImage.absoluteUrl; let index = $index) {
						<div libFlexColumn>
							<lib-image
								[alt]="'Image preview'"
								[imageSize]="'250px'"
								[isResponsive]="true"
								[maxHeight]="150"
								[image]="image"
								[isRound]="false"
								[dialogPreviewImage]="image"
							></lib-image>
						</div>
						}
					</div>
				</div>
				}

				<div libFlexColumn libFlexFill>
					<div>
						<div libFlexRow [libFlexRowGap]="'8px'">
							<div libFlexColumn libFlexFill>
								<h4 libLineClamp class="title" [clampLines]="2">
									{{ item.name }}
								</h4>
							</div>
						</div>

						@if (item.infoTableItems.length) { @for (infoTableItem of item.infoTableItems; track
						infoTableItem.title; let first = $first) {
						<div
							[class.push-top-xs]="!first"
							[class.push-top-sm]="first"
							libFlexRow
							[libFlexRowGap]="'8px'"
						>
							<div libText3 libFlexColumn [libFlexSize]="'120px'">{{ infoTableItem.title }}:</div>
							<div libText2 libFlexColumn libFlexFill>{{ infoTableItem.value }}</div>
						</div>
						}}
					</div>
				</div>
			</div>
			}
		</ng-template>

		<div>
			<ng-template [ngTemplateOutlet]="exerciseTemplate"></ng-template>
			@if (!last) {
			<lib-divider class="push-top-sm push-bottom-sm" [mode]="'dotted'"></lib-divider>
			}
		</div>
	</div>

	} } @if (showLoadMore() === true) {
	<div class="push-top-md" libFlexRow [libFlexRowAlign]="'center'">
		<div libFlexColumn>
			<lib-button [buttonType]="'basic'" (click)="handleLoadMore()">
				<span>
					Show more @if (showLoadMoreCount(); as count) {
					<span>(+{{ count }})</span>
					}
				</span>
			</lib-button>
		</div>
	</div>
	} }
</div>

} }
